<template>
    <div :class="{loading: isLoading}">

        <div v-if="alreadyVisited" class="iconModal">

            <div class="icon">
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_356_5101)">
                        <path d="M11 21.5C16.5228 21.5 21 17.0228 21 11.5C21 5.97715 16.5228 1.5 11 1.5C5.47715 1.5 1 5.97715 1 11.5C1 17.0228 5.47715 21.5 11 21.5Z" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11 7.5V11.5" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11 15.5H11.01" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_356_5101">
                            <rect width="22" height="22" fill="white" transform="translate(0 0.5)"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

            <div class="data">
                <div class='title'>
                    {{settings?.reject_title}}
                </div>
                <div class='text'>
                    {{settings?.reject_message}}
                </div>
            </div>

        </div>

        <div v-else>
            <div class='title'>
                {{settings?.title}}
                <span>{{settings?.title_span}}</span>
            </div>

            <div class="buttons" v-if="settings.buttons && Object.keys(settings.buttons).length > 0">
                <a href="#" @click.prevent="additionModal" class="yes button">{{settings.buttons.yes}}</a>
                <a :href="dataHref" @click="scrollToNext" target="_blank" class="no button" :data-id="dataId" :data-rid="dataRid">{{settings.buttons.no}}</a>
            </div>
        </div>

    </div>
</template>

<script setup>
import * as functions from '@/assets/js/Functions';
import {onMounted, reactive, ref} from "vue";
import axios from "axios";
import qs from "qs";

const emit = defineEmits(['close'])
const props = defineProps({
    trigger: Object,
    params: Object,
});
const isLoading = ref(true);
const alreadyVisited = ref(false);
const settings = ref({});

const dataId = functions.attr(props.trigger, 'data-id')
const dataRid = functions.attr(props.trigger, 'data-rid')
const dataHref = functions.attr(props.trigger, 'href')

const additionModal = () => {
    alreadyVisited.value = true
}

const closeModal = () => {
    emit('close');
}
const scrollToNext = () => {
    let parent = functions.parent(props.trigger, 'div.offer')
    let nextOffer = functions.next(parent)
    if(nextOffer) nextOffer.scrollIntoView({ behavior: 'smooth' })
    closeModal()
}

const openOffer = () => {
    window.open(dataHref, "_blank")
    closeModal()
}

onMounted(async () => {
    let count = checkCount()
    if( count === false) return openOffer()

    functions.ajax({
        action: 'get_modal_data',
        modal: 'VisitOffer'
    },function(res){
        console.log(res)
        settings.value = res
        if(!sessionStorage.getItem('questionModal')){
            sessionStorage.setItem('questionModal', JSON.stringify(res));
            sessionStorage.setItem('modalCount', '1');
        }else{
            checkCount(true)
        }
        isLoading.value = false;
    })
})

function checkCount(increment = false) {
    let settings = JSON.parse(sessionStorage.getItem('questionModal'))
    let count = parseInt(sessionStorage.getItem('modalCount'))
    if( settings && settings.modal_count && count >= settings.modal_count){
        sessionStorage.setItem('VisitOffer', "0")
        return false
    }
    if(increment){
        count++
        sessionStorage.setItem('modalCount', count)
        return count
    }
}
</script>